import React from 'react';
import Header from '../components/Header'
import BoxWrapper from '../components/BoxWrapper/BoxWrapper';
import List from './price/List'

const Dashboard = ()=>{
	return (
		<>
			<Header/>

			<BoxWrapper>
				<List/>
			</BoxWrapper>
		</>
		)
}

export default Dashboard